<template>
    <div v-if="state" class="flex flex-col overflow-hidden bg-white shadow-wide">
        <div
            v-if="listHeading"
            class="flex items-center justify-between p-5 text-blue-500 bg-yellow-200 flex-0"
            :class="{ 'sm:py-6 sm:px-12': !slim }"
        >
            <p class="h2">{{ listHeading }}</p>
            <img class="w-12 h-12" :src="`/dist/images/geosearch/All Extras.svg`" alt="" />
        </div>

        <div id="print" class="flex-1 px-6 overflow-y-auto" :class="{ 'sm:p-12 sm:pt-8': !slim }">
            <slot :items="state.hits" :expand-all="expandAll" />
        </div>

        <ais-stats
            v-slot="{ nbHits }"
            class="flex items-center justify-between px-6 py-4 border-t border-blue-100 flex-0"
            :class="{ 'sm:px-12 sm:py-6': !slim }"
        >
            <button aria-label="Print page" @click="printPage">
                <svg class="w-8 h-8 text-blue-500" fill="none" role="img" focusable="false">
                    <circle cx="16" cy="16" r="15.25" class="stroke-current" stroke-width="1.5" />
                    <path
                        d="M11.252 18.376h9.5v3.75c0 .69-.56 1.25-1.25 1.25h-7c-.69 0-1.25-.56-1.25-1.25v-3.75zM20.752 13.601h-9.5V9.874c0-.69.56-1.25 1.25-1.25h7c.69 0 1.25.56 1.25 1.25v3.727z"
                        class="stroke-current"
                        stroke-width="1.5"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.502 14.35h13a.5.5 0 01.5.5v4.712a.5.5 0 01-.5.5h-1.526v1.5h1.526a2 2 0 002-2V14.85a2 2 0 00-2-2h-13a2 2 0 00-2 2v4.712a2 2 0 002 2h1.74v-1.5h-1.74a.5.5 0 01-.5-.5V14.85a.5.5 0 01.5-.5z"
                        class="fill-current"
                    />
                    <circle cx="21.113" cy="16.124" r=".75" class="fill-current" />
                </svg>
            </button>

            <p class="text-sm text-grey-500">{{ nbHits }} Results</p>
        </ais-stats>

        <!-- <template v-if="state && state.items.length">
            <ais-hits>
                <div slot-scope="{ items }">
                    <p v-if="!items.length" class="search-alert">
                        No results found. Enter a new search above or try map view and zoom in to
                        choose an area to search
                    </p>
                </div>
            </ais-hits>
        </template>-->
    </div>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectHits } from 'instantsearch.js/es/connectors';

export default {
    mixins: [createWidgetMixin({ connector: connectHits })],

    props: {
        slim: {
            type: Boolean,
            default: false
        },
        listHeading: {
            type: String,
            default: undefined
        }
    },

    data() {
        return {
            expandAll: false
        };
    },

    methods: {
        printPage() {
            this.expandAll = true;

            setTimeout(() => {
                this.$htmlToPaper(
                    'print',
                    {
                        styles: ['/dist/app.css']
                    },
                    () => {
                        this.expandAll = false;
                    }
                );
            }, 1000);
        }
    }
};
</script>
